import request, {requestJson} from '../main';
const service = ""
class IntegrityApi {
    private url: string = service + "/integrity";
    //提交审核
    public submitAuditOrder(args: any){
        return requestJson({
            url: this.url + '/submit-audit-order',
            method: 'post',
            data: args
        })
    }
    //审核列表
    public list(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    //审核记录
    public listRecord(args: any){
        return request({
            url: this.url + '/page-record',
            method: 'get',
            params: args
        })
    }

    public listBySate(args: any){
        return request({
            url: this.url + '/list-by-sate',
            method: 'get',
            params: args
        })
    }
    //列表中器具详情
    public listOrderDetails(args: any){
        return request({
            url: this.url + '/list-order-details',
            method: 'get',
            params: args
        })
    }

    //备案列表
    public auditOrders(args: any){
        return request({
            url: this.url + '/audit-orders',
            method: 'get',
            params: args
        })
    }
    //订单分配
    public auditOrderDistribute(args: any){
        return request({
            url: this.url + '/audit-order-distribute',
            method: 'post',
            data: args
        })
    }
    //备案详情
    public getOrderDetail(args: any){
        return request({
            url: this.url + '/get-order-detail',
            method: 'get',
            params: args
        })
    }
    //审核员更新审核状态
    public checkOrder(args: any){
        return request({
            url: this.url + '/checkOrder',
            method: 'post',
            data: args
        })
    }
    //删除订单
    public deleteIntegrity(args: any){
        return request({
            url: this.url + '/del-integrity',
            method: 'post',
            data: args
        })
    }
    //退回
    public returnAuditOrder(args: any){
        return request({
            url: this.url + '/return-audit-order',
            method: 'get',
            params: args
        })
    }
    //提交备案前获取目标行政单位
    public getAudit(args: any){
        return request({
            url: this.url + '/get-audit',
            method: 'get',
            params: args
        })
    }
    //备案不通过的接口
    public orderNotPass(args: any){
        return requestJson({
            url: this.url + '/order-not-pass',
            method: 'post',
            data: args
        })
    }

    public listCultural(args: any){
        return request({
            url: '/cultural/page-list',
            method: 'get',
            params: args
        })
    }

    public pageComplaint(args: any){
        return request({
            url: '/creditFile/page-complaint',
            method: 'get',
            params: args
        })
    }


    public addComplaint(args: any){
        return request({
            url: '/creditFile/add-complaint',
            method: 'post',
            data: args
        })
    }

    public deleteComplaint(args: any){
        return request({
            url: '/creditFile/del-complaint',
            method: 'post',
            data: args
        })
    }


    public addSupervise(args: any){
        return request({
            url: '/creditFile/add-supervise',
            method: 'post',
            data: args
        })
    }

    public deleteSupervise(args: any){
        return request({
            url: '/creditFile/del-supervise',
            method: 'post',
            data: args
        })
    }


    public pageSupervise(args: any){
        return request({
            url: '/creditFile/page-supervise',
            method: 'get',
            params: args
        })
    }


    public addPunish(args: any){
        return request({
            url: '/creditFile/add-punish',
            method: 'post',
            data: args
        })
    }
    public deletePunish(args: any){
        return request({
            url: '/creditFile/del-punish',
            method: 'post',
            data: args
        })
    }

    public pagePunish(args: any){
        return request({
            url: '/creditFile/page-punish',
            method: 'get',
            params: args
        })
    }


    public saveCultural(args: any){
        return request({
            url: '/cultural/add-or-update',
            method: 'post',
            data: args
        })
    }
    public getCultural(args: any){
        return request({
            url: '/cultural/get-detail',
            method: 'get',
            params: args
        })
    }
    public deleteCultural(args: any){
        return request({
            url: '/cultural/delete',
            method: 'post',
            data: args
        })
    }

    //企业公示申请添加或者编辑
    public addOrUpdate(args: any){
        return request({
            url: this.url + '/add-or-update',
            method: 'post',
            data: args
        })
    }

    //模板文件列表
    public listFiles(args: any){
        return request({
            url: this.url + '/list-files',
            method: 'get',
            params: args
        })
    }

    // 提交
    public changeState(args: any){
        return request({
            url: this.url + '/change-state',
            method: 'post',
            data: args
        })
    }

    // 单位信息确认
    public mechanismConfirm(args: any){
        return request({
            url: this.url + '/confirm-org',
            method: 'post',
            data: args
        })
    }

    //获取统计数据
    public listStatistics(){
        return request({
            url: this.url + '/list-statistics',
            method: 'get'
        })
    }

    //获取行政机构
    public getAdministrativeAgency(){
        return request({
            url: this.url + '/get-administrative-agency',
            method: 'get'
        })
    }

    //导出数据
    public exportData(args: any){
        return request({
            url: this.url + '/export-data',
            method: 'post',
            data: args
        })
    }

    //扫码展示承诺书数据
    public get(args: any){
        return request({
            url: this.url + '/get',
            method: 'get',
            params: args
        })
    }

    // 重新生成承诺书
    public generateSpecialMark(args: any){
        return request({
            url: this.url + '/generate-specialMark',
            method: 'post',
            data: args
        })
    }

    // 取消撤销
    public unbanCancel(args: any){
        return request({
            url: this.url + '/unban-cancel',
            method: 'post',
            data: args
        })
    }

    // 下载承诺书
    public downloadPromises(args: any){
        return request({
            url: this.url + '/download-promises',
            method: 'post',
            data: args
        })
    }

    // 违规数量查询
    public numberOfViolations(){
        return request({
            url: this.url + '/number-of-violations',
            method: 'get',
        })
    }

    // 修改已读未读状态
    public changeHandle(id: string){
        return request({
            url: this.url + '/change-handle',
            method: 'post',
            data: {id: id}
        })
    }

    // 未读任务数量
    public notHandleCount(){
        return request({
            url: this.url + '/not-handle-count',
            method: 'get',
        })
    }
}
const integrityApi = new IntegrityApi();
export {integrityApi}
